/* unplugin-vue-components disabled */import { render } from "./test.vue?vue&type=template&id=3b3ebfc6&scoped=true"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"

import "./test.vue?vue&type=style&index=0&id=3b3ebfc6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3ebfc6"]])

export default __exports__